"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useRowActions = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_redux_1 = require("react-redux");
var react_router_dom_1 = require("react-router-dom");
var subscriptions_1 = require("../../../../../../../reducers/slices/subscriptions/subscriptions");
var react_1 = require("react");
var routes_1 = require("../../../../../../../constants/routes");
var main_1 = require("../../../../../../../reducers/slices/main");
var cancel_user_subscription_1 = require("../../../../../../../api/calls/subscription/cancel_user_subscription");
var revoke_user_subscription_1 = require("../../../../../../../api/calls/subscription/revoke_user_subscription");
var get_user_subscription_thunk_1 = require("../../../../../../../reducers/slices/subscriptions/thunks/get_user_subscription_thunk");
var react_2 = require("@nextui-org/react");
var react_3 = require("@iconify/react");
function useRowActions() {
    var _this = this;
    var navigate = (0, react_router_dom_1.useNavigate)();
    var dispatch = (0, react_redux_1.useDispatch)();
    var customer = (0, react_redux_1.useSelector)(function (state) { return state.customerState; }).customer;
    var user = (0, react_redux_1.useSelector)(function (state) { return state.userState; }).user;
    var clientUsers = (0, react_redux_1.useSelector)(function (state) { return state.clientState; }).clientUsers;
    var userSubscriptionPagination = (0, react_redux_1.useSelector)(function (state) { return state.subscriptionsState; }).userSubscriptionPagination;
    var loggedInUser = clientUsers === null || clientUsers === void 0 ? void 0 : clientUsers.find(function (clientUser) { return clientUser.user_id === (user === null || user === void 0 ? void 0 : user._id); });
    var params = (0, react_router_dom_1.useParams)();
    var id = params.id;
    var getCustomerSubscriptionList = function (query) { return __awaiter(_this, void 0, void 0, function () { return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, dispatch((0, get_user_subscription_thunk_1.get_user_subscription_thunk)(query))];
            case 1: return [2 /*return*/, _a.sent()];
        }
    }); }); };
    var rowActions = function (cellValue) { return [
        {
            key: "view",
            onClick: function () {
                dispatch((0, subscriptions_1.setSelectedSubscription)(cellValue));
                navigate("".concat(routes_1.CONSOLE_ROUTE).concat(routes_1.SUBSCRIPTIONS_DETAILS_ROUTE, "/").concat(cellValue._id));
            },
        },
        {
            key: "cancel",
            onClick: function () {
                var _a, _b;
                var subscription = cellValue;
                var redemption = subscription.redemption;
                var cancelSentence = "Are you sure you want to CANCEL ".concat(subscription === null || subscription === void 0 ? void 0 : subscription.name, "?");
                if (clientUsers === null || clientUsers === void 0 ? void 0 : clientUsers.length) {
                    if ((redemption === null || redemption === void 0 ? void 0 : redemption.status) !== "CANCELLED") {
                        if ((_b = (_a = loggedInUser === null || loggedInUser === void 0 ? void 0 : loggedInUser.user_permissions) === null || _a === void 0 ? void 0 : _a.SUBSCRIPTIONS) === null || _b === void 0 ? void 0 : _b.update) {
                            dispatch((0, main_1.setContentModal)({
                                title: "Confirm",
                                content: ((0, jsx_runtime_1.jsxs)("div", __assign({ className: "flex pt-4 gap-4" }, { children: [(0, jsx_runtime_1.jsxs)("label", { children: [" ", cancelSentence] }), (0, jsx_runtime_1.jsxs)(react_2.Button, __assign({ color: "primary", onPress: function () {
                                                dispatch((0, main_1.setContentModal)(null));
                                            }, radius: "sm" }, { children: ["Cancel ", (0, jsx_runtime_1.jsx)(react_3.Icon, { icon: "solar:forbidden-circle-linear", width: "24", height: "24" })] })), (0, jsx_runtime_1.jsxs)(react_2.Button, __assign({ color: "primary", onPress: function () {
                                                if (redemption === null || redemption === void 0 ? void 0 : redemption._id) {
                                                    (0, cancel_user_subscription_1.cancel_user_subscription)({ user_id: id, redemption_id: redemption === null || redemption === void 0 ? void 0 : redemption._id }).then(function (response) { return __awaiter(_this, void 0, void 0, function () {
                                                        return __generator(this, function (_a) {
                                                            switch (_a.label) {
                                                                case 0:
                                                                    if (!response.success) return [3 /*break*/, 2];
                                                                    dispatch((0, main_1.setMessageModal)({ title: "Success...", messages: [response.message] }));
                                                                    dispatch((0, main_1.setContentModal)(null));
                                                                    return [4 /*yield*/, getCustomerSubscriptionList({
                                                                            user_id: id,
                                                                            page: userSubscriptionPagination.page,
                                                                            size: userSubscriptionPagination.size,
                                                                        })];
                                                                case 1:
                                                                    _a.sent();
                                                                    return [3 /*break*/, 3];
                                                                case 2:
                                                                    dispatch((0, main_1.setMessageModal)({
                                                                        title: "Something went wrong when cancelling subscription.",
                                                                        messages: [response.message],
                                                                    }));
                                                                    _a.label = 3;
                                                                case 3: return [2 /*return*/];
                                                            }
                                                        });
                                                    }); });
                                                }
                                            }, radius: "sm" }, { children: ["Continue ", (0, jsx_runtime_1.jsx)(react_3.Icon, { icon: "solar:check-circle-linear", width: "24", height: "24" })] }))] }))),
                            }));
                        }
                        else {
                            dispatch((0, main_1.setMessageModal)({
                                title: "You do not have permission to cancel subscriptions.",
                                messages: [""],
                            }));
                        }
                    }
                    else {
                        dispatch((0, main_1.setMessageModal)({
                            title: "".concat(subscription === null || subscription === void 0 ? void 0 : subscription.name, " for ").concat(customer === null || customer === void 0 ? void 0 : customer.name, " ").concat(customer === null || customer === void 0 ? void 0 : customer.surname, " has already been cancelled."),
                            messages: [""],
                        }));
                    }
                }
            },
        },
        {
            key: "revoke",
            onClick: function () {
                var _a, _b;
                var subscription = cellValue;
                var redemption = subscription.redemption;
                var revokeSentence = "Are you sure you want to REVOKE ".concat(subscription === null || subscription === void 0 ? void 0 : subscription.name, "?");
                if (clientUsers === null || clientUsers === void 0 ? void 0 : clientUsers.length) {
                    if ((redemption === null || redemption === void 0 ? void 0 : redemption.status) !== "REVOKED") {
                        if ((_b = (_a = loggedInUser === null || loggedInUser === void 0 ? void 0 : loggedInUser.user_permissions) === null || _a === void 0 ? void 0 : _a.SUBSCRIPTIONS) === null || _b === void 0 ? void 0 : _b.update) {
                            dispatch((0, main_1.setContentModal)({
                                title: "Confirm",
                                content: ((0, jsx_runtime_1.jsxs)("div", __assign({ className: "flex pt-4 gap-4" }, { children: [(0, jsx_runtime_1.jsxs)("label", { children: [" ", revokeSentence] }), (0, jsx_runtime_1.jsxs)(react_2.Button, __assign({ color: "primary", onPress: function () {
                                                dispatch((0, main_1.setContentModal)(null));
                                            }, radius: "sm" }, { children: ["Cancel ", (0, jsx_runtime_1.jsx)(react_3.Icon, { icon: "solar:forbidden-circle-linear", width: "24", height: "24" })] })), (0, jsx_runtime_1.jsxs)(react_2.Button, __assign({ color: "primary", onPress: function () {
                                                if (redemption === null || redemption === void 0 ? void 0 : redemption._id) {
                                                    (0, revoke_user_subscription_1.revoke_user_subscription)({ user_id: id, subscription_id: redemption === null || redemption === void 0 ? void 0 : redemption._id, billable: false }).then(function (response) { return __awaiter(_this, void 0, void 0, function () {
                                                        return __generator(this, function (_a) {
                                                            switch (_a.label) {
                                                                case 0:
                                                                    if (!response.success) return [3 /*break*/, 2];
                                                                    dispatch((0, main_1.setMessageModal)({ title: "Success...", messages: [response.message] }));
                                                                    dispatch((0, main_1.setContentModal)(null));
                                                                    return [4 /*yield*/, getCustomerSubscriptionList({
                                                                            user_id: id,
                                                                            page: userSubscriptionPagination.page,
                                                                            size: userSubscriptionPagination.size,
                                                                        })];
                                                                case 1:
                                                                    _a.sent();
                                                                    return [3 /*break*/, 3];
                                                                case 2:
                                                                    dispatch((0, main_1.setMessageModal)({
                                                                        title: "Something went wrong when revoking subscription.",
                                                                        messages: [response.message],
                                                                    }));
                                                                    _a.label = 3;
                                                                case 3: return [2 /*return*/];
                                                            }
                                                        });
                                                    }); });
                                                }
                                            }, radius: "sm" }, { children: ["Continue ", (0, jsx_runtime_1.jsx)(react_3.Icon, { icon: "solar:check-circle-linear", width: "24", height: "24" })] }))] }))),
                            }));
                        }
                        else {
                            dispatch((0, main_1.setMessageModal)({
                                title: "You do not have permission to revoke subscriptions.",
                                messages: [""],
                            }));
                        }
                    }
                    else {
                        dispatch((0, main_1.setMessageModal)({
                            title: "".concat(subscription === null || subscription === void 0 ? void 0 : subscription.name, " for ").concat(customer === null || customer === void 0 ? void 0 : customer.name, " ").concat(customer === null || customer === void 0 ? void 0 : customer.surname, " has already been revoked."),
                            messages: [""],
                        }));
                    }
                }
            },
        },
    ]; };
    return (0, react_1.useMemo)(function () { return ({
        rowActions: rowActions,
    }); }, [rowActions]);
}
exports.useRowActions = useRowActions;
